/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_ScheduledInputs */

const en_settings_history_scheduled = /** @type {(inputs: Settings_History_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled`)
};

const id_settings_history_scheduled = /** @type {(inputs: Settings_History_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjadwal`)
};

/**
* | output |
* | --- |
* | "Scheduled" |
*
* @param {Settings_History_ScheduledInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_scheduled = /** @type {((inputs?: Settings_History_ScheduledInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_ScheduledInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_scheduled(inputs)
	return en_settings_history_scheduled(inputs)
});